import { http } from './config'

export default {
  getGeneralSetups: () => {
    return http.get('general_setups')
  },

  getGeneralSetupById: (generalSetupId) => {
    return http.get('general_setups/' + generalSetupId)
  },

  createSetup: (generalSetupParams) => {
    return http.post('general_setups', {
      cdn: generalSetupParams.cdn,
    })
  },

  updateGeneralSetup: (generalSetupParams) => {
    return http.put('general_setups/' + generalSetupParams.id, {
      cdn: generalSetupParams.cdn,
    })
  },
}
